import React, { FC, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

type SimpleDropMenuPropsType = {
  children: React.ReactNode;
  menu: React.ReactNode;
};

const SimpleDropMenu: FC<SimpleDropMenuPropsType> = ({ children, menu }) => {
  const triggerRef = useRef<HTMLDivElement | null>(null);
  const menuRef = useRef<HTMLDivElement | null>(null);

  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  const updatePosition = () => {
    if (!triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();

    setPos({
      top: rect.bottom + window.scrollY + 8,
      left: rect.left + window.scrollX,
    });
  };

  const toggle = () => {
    if (!open) updatePosition();
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;

      if (triggerRef.current?.contains(target) || menuRef.current?.contains(target)) {
        return; // клик внутри — НЕ закрываем
      }

      setOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      {/* trigger */}
      <div ref={triggerRef} onClick={toggle} style={{ display: 'flex' }} className="cursor-pointer">
        {children}
      </div>

      {/* portal menu */}
      {open &&
        createPortal(
          <div
            ref={menuRef}
            style={{
              position: 'absolute',
              top: pos.top,
              left: pos.left,
              zIndex: 9999,
            }}
          >
            <div
              style={{
                filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.25))',
              }}
            >
              <div
                style={{
                  width: 0,
                  height: 0,
                  marginLeft: 6,
                  borderLeft: '6px solid transparent',
                  borderRight: '6px solid transparent',
                  borderBottom: '6px solid #fff',
                }}
              />
            </div>

            <div
              style={{
                background: '#fff',
                borderRadius: 8,
                padding: 8,
                minWidth: 160,
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
              }}
            >
              {menu}
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};

export default SimpleDropMenu;
